import { render } from "./RecordPlan.vue?vue&type=template&id=1aa310bf"
import script from "./RecordPlan.vue?vue&type=script&lang=js"
export * from "./RecordPlan.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__